// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7fa69729","453":"4bc01001"}[chunkId] + ".chunk.js";
};